import React from 'react';
import { Select } from 'antd';
import _ from 'lodash';
import styled from 'styled-components';

import { prepareDropdown } from '../../utils/common';
import { revenueQueryTypes, revenueQueryTypesView } from '../../constants/revenue';
import { groupByExcludeFields, splitByExcludeFields } from '../../constants/metainf';
import FieldsSelect from '../common/FieldsSelect';
import AmountSelect from './AmountSelect';

const StyledRevenueMainOptionsBarContainer = styled.div`
  .label-by {
    margin: 0 5px;
  }

  .label-split-by {
    margin-right: 5px;
  }

  .label-amount {
    margin-left: 10px;
  }
`;

const StyledSelect = styled(Select)`
  width: auto;
  min-width: 120px;
`;

const { Option } = Select;

const getFields = (metainf, extraGroups) =>
  _.isNil(metainf) ? [] : prepareDropdown(metainf, true, extraGroups);

const RevenueMainOptionsBar = ({
  queryType,
  groupColumn,
  splitColumn,
  metainf,
  onChangeQueryType,
  onChangeGroupColumn,
  onChangeSplitColumn,
  field,
  fields,
  onChangeAmount,
}) => {
  const metainfFields = getFields(metainf, groupByExcludeFields);

  // ! скрытие Quarter в выпадающем списке
  const transformMetainfFields = metainfFields.map((fieldItem) => {
    let filteredField = fieldItem;

    if (fieldItem.title === 'Time') {
      const fieldWithoutQuater = fieldItem.fields.filter((item) => {
        return item.name !== 'Quarter';
      });
      filteredField = { ...filteredField, fields: fieldWithoutQuater };
    }
    return filteredField;
  });

  return (
    <StyledRevenueMainOptionsBarContainer>
      <StyledSelect
        onSelect={(qt) => onChangeQueryType(qt)}
        value={queryType}
        dropdownMatchSelectWidth={false}
        dropdownStyle={{ width: 'auto' }}
        className="ant-select-border-bottom"
        getPopupContainer={(triggerNode) => triggerNode}
        virtual={false}
      >
        {Object.values(revenueQueryTypes).map((option) => (
          <Option key={option} value={option}>
            {revenueQueryTypesView[option]}
          </Option>
        ))}
      </StyledSelect>
      <span className="label-by">by</span>
      <FieldsSelect
        onSelect={(groupColumnParam) => onChangeGroupColumn(groupColumnParam)}
        value={groupColumn}
        fields={transformMetainfFields}
        style={{ width: 'auto', minWidth: 120, marginRight: 5 }}
        allowClear={false}
      />
      <span className="label-split-by">split by</span>
      <FieldsSelect
        onSelect={(splitColumnParam) => onChangeSplitColumn(splitColumnParam)}
        value={splitColumn}
        fields={getFields(metainf, splitByExcludeFields)}
        style={{ width: 'auto', minWidth: 140 }}
        allowClear
      />
      <span className="label-amount">
        <AmountSelect field={field} fields={fields} onChange={onChangeAmount} />
      </span>
    </StyledRevenueMainOptionsBarContainer>
  );
};

export default RevenueMainOptionsBar;
